<template>
  <div class="persons-list">
    <div
      v-for="item in items"
      :key="'person_'+item.id"
      class="persons-list__item person-item">
      <div class="person-item__type">{{ item.get_type_person_display }}</div>
      <div class="person-item__content">
        <div class="person-item__name">
          <div class="person-item__overflow-text">{{ item.first_name }}&nbsp;{{ item.third_name }}&nbsp;{{ item.second_name }}</div>
        </div>
        <div class="person-item__actions">
          <button
            @click="editItem(item)"
            type="button" class="person-item__edit"><i class="fa fa-pen-to-square"></i></button>
          <delete-row-dialog
            @delete-confirm="deleteItem(item)"
            class="person-item__delete">
            <template v-slot:header>
              Удалить строку?
            </template>
            <template v-slot:body>
              <p>{{ item.first_name }}&nbsp;{{ item.third_name }}&nbsp;{{ item.second_name }}</p>
            </template>
          </delete-row-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import DeleteRowDialog from './DeleteRowDialog.vue'


export default {

  name: 'FamilyPersonsList',
  props: {
    items: {
      type: Array,
      default: null
    }
  },

  components: {
    DeleteRowDialog
  },

  data () {
    return {
      errors: {}
    }
  },

  methods: {
    editItem (instance) {
      this.$emit('edit', instance)
    },
    deleteItem (instance) {

      axios.delete(`/ancet/api/family-person/${instance.id}/`, {params: {ancet_id: instance.ancet}})
        .then(() => {
          this.$emit('delete', instance)
        })
        .catch(error => {
          this.errors = error.response.data
        })

    }
  }
}
</script>

<style lang="css" scoped>
</style>